import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import { withRouter } from "react-router-dom";
import Constants from "Utils/Constants";
import TasksMenu from "./TasksMenu";
import { ToolbarButton } from "Common/ToolbarButton";
import { openTaskHistory } from "TaskHistory";
import { useSelector } from "react-redux";
import Toolbar from "@material-ui/core/Toolbar";

const AccountDetailToolbar = function(props) {
  const { accountdetailrow, AccountDetailData, loadData } = props;
  const user = useSelector(({ rootScope }) => rootScope.user);
  return (
    <Toolbar
      style={getStyleJSON(
        `background-color: var(--menubarbackgroundcolor);min-height: auto;`
      )}
    >
      <div layout="row" className="layout-row">
        <div>
          <h1 className="ng-binding">{AccountDetailData.playerservername}</h1>
          <TasksMenu
            accountdetailrow={accountdetailrow}
            AccountDetailData={AccountDetailData}
          />
          <ToolbarButton
            label={"Refresh"}
            tooltip={`Refresh account data. Use this option if something in game has changed and not reflecting here.`}
            onClick={loadData}
          />
          <ToolbarButton
            label={"Task History"}
            tooltip={`Open Task History.`}
            onClick={() =>
              openTaskHistory(
                user,
                accountdetailrow.server,
                accountdetailrow.account,
                props.history
              )
            }
          />
          <ToolbarButton
            label={"Accounts"}
            tooltip={`Click to go back to Accounts Screen.`}
            onClick={() => props.history.push(Constants.accounts)}
          />
        </div>
      </div>
    </Toolbar>
  );
};

export default withRouter(AccountDetailToolbar);
